<script>
import { Pie, mixins  } from 'vue-chartjs'
const { reactiveProp } = mixins

export default {
  extends: Pie,
  mixins: [reactiveProp],
  props: {
    chartData: {
      type: Object,
      default: null
    },
    options: {
      type: Object,
      default: null
    }
  },
  mounted () {
    var _this = this;
    let option = this.options || {};
    option.onClick=function(event, array) {
              _this.$emit("click", {event, array});
        };
    this.renderChart(this.chartData,option)
  },
}
</script>
